import { useEffect } from "react";
import ContactHeader from "../components/ContactHeader";
import ContactTabs from "../components/ContactTabs";
import useAdminContactStore from "../../../store/adminContactStore";
import usecontactAccessStore from "../../../store/contactAccessStore";
import { getContactMenuPermissions } from "../service/adminContact_service";

const ContactDetailsPage = () => {
    const selectedContact = useAdminContactStore((state)=>state.adminContact);
    const setMenuPermissionsList = usecontactAccessStore((state) => state.setMenuPermissionsList);

    const fetchContactMenuPermissions = async() => {
      try{
        const response = await getContactMenuPermissions(selectedContact.webUserId);
        setMenuPermissionsList(response.data);
      }
      catch{
        setMenuPermissionsList([]);
      }
    }
    useEffect(()=>{
      if(selectedContact.webUserId){
        fetchContactMenuPermissions();
      }
    },[selectedContact])
  return (
    <section style={{ paddingTop: "15px" }}>
      <ContactHeader selectedContact={selectedContact}/>
      <ContactTabs selectedContact={selectedContact}/>
    </section>
  );
};

export default ContactDetailsPage;